module.exports = __webpack_public_path__ + "static/media/product-6.ec60efb7.jpg";